import { Phone, Mail } from "lucide-react";
import { CONTACT, mailto } from "@/data/content";
import { FadeUp, SectionTag } from "@/components/Reveal";

const CTASection = ({
  title = ["Erzählen Sie uns", "von Ihrem Moment."],
  text = "Ob Trauung, Willkommensfeier oder Jubiläum – jedes Gespräch beginnt unverbindlich. Rufen Sie an oder schreiben Sie uns, wir antworten persönlich.",
  buttonLabel = "Zeremonie anfragen",
  subject = "Anfrage Zeremonie",
}) => (
  <section data-testid="cta-section" className="relative overflow-hidden bg-moss text-creme">
    <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full border border-creme/10" />
    <div className="pointer-events-none absolute -bottom-32 -left-16 h-80 w-80 rounded-full border border-creme/10" />
    <div className="mx-auto max-w-5xl px-5 py-24 text-center sm:px-8 sm:py-32">
      <FadeUp>
        <SectionTag dark>Kontakt</SectionTag>
        <h2 className="mt-6 font-serif text-4xl leading-[1.08] sm:text-6xl">
          {title[0]}<br />
          <span className="font-accent italic text-sand">{title[1]}</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-creme/75">{text}</p>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            href={mailto(subject)}
            data-testid="cta-mail-button"
            className="inline-flex w-full items-center justify-center gap-3 rounded-full bg-creme px-9 py-4 text-sm font-bold text-mossdeep transition-transform duration-300 hover:scale-[1.03] sm:w-auto"
          >
            <Mail size={16} /> {buttonLabel}
          </a>
          <a
            href={CONTACT.phoneHref}
            data-testid="cta-phone-button"
            className="inline-flex w-full items-center justify-center gap-3 rounded-full border border-creme/30 px-9 py-4 text-sm font-semibold text-creme transition-colors duration-300 hover:border-sand hover:text-sand sm:w-auto"
          >
            <Phone size={16} /> {CONTACT.phone}
          </a>
        </div>
        <p className="mt-6 text-xs text-creme/50">Unverbindlich & persönlich – wir melden uns innerhalb von 24 Stunden.</p>
      </FadeUp>
    </div>
  </section>
);

export default CTASection;
